module.exports = __webpack_public_path__ + "static/media/nodejs.ccb43d34.svg";